import script from "./reservationMail.vue?vue&type=script&setup=true&lang=js"
export * from "./reservationMail.vue?vue&type=script&setup=true&lang=js"

import "./reservationMail.vue?vue&type=style&index=0&id=b9602762&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9602762"]])

export default __exports__